export default "__VITE_ASSET__D6$NJmh5__"